import { action, makeObservable, observable } from 'mobx';
import { Message, StoreNode, StoreNodeProps } from '../../store';
import { Store } from '../../store/store';
import { WindowState } from '../../components/overlays';

export class TrainerKeyboardShortcutsWindowState
  extends StoreNode {

  readonly nodeType = 'TrainerKeyboardShortcutsWindow';

  constructor(store: Store, props?: StoreNodeProps) {
    super(store, props);
    makeObservable(this, {
      isLoading: observable,
      open: action,
      close: action,
    });
    this.window.listen(
      this.windowListener);
  }

  isLoading = false;

  private windowListener = (msg: Message<WindowState>) => {
    switch (msg.type) {
      case 'close':
      case 'outsideClick':
        if (this.isLoading)
          return;
        this.close();
        break;
    }
  }
  readonly window = new WindowState(this.store);

  open() {
    this.dispatch('Overlays', 'openWindow', { name: 'TrainerKeyboardShortcutsWindow' });
  }

  close() {
    this.dispatch('Overlays', 'closeWindow');
  }
}